(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskDetailController', TaskDetailController);

    TaskDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Task', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'HandbookVersion'];

    function TaskDetailController($scope, $rootScope, $stateParams, previousState, entity, Task, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, HandbookVersion) {
        var vm = this;

        vm.task = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:taskUpdate', function(event, result) {
            vm.task = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
